export default {
  CompanySelection__SAVE_BUTTON: "Save",
  CompanySelection__SELECT_COMPANY_LABEL: "Select company",
  CompanySelection__RADIO_BUTTON_ARIA_LIVE: (data) =>
    `RadioButton group. ${data.name} option selected. ${data.index} of ${data.length}`,
};
